import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LogoImg from "../../../assets/images/logo/logo.png";

const Wrapper = styled.div`
  height: ${({ $height }) => ($height ? $height : "120px")};
  cursor: pointer;
  img {
    height: 100%;
    width: auto;
    object-fit: contain;
  }
`;
function Logo({ height }) {
  const navigate = useNavigate();
  return (
    <Wrapper
      $height={height}
      onClick={() => {
        navigate("/");
      }}
    >
      <img src={LogoImg} alt="Aura Metals Logo" />
    </Wrapper>
  );
}

export default Logo;
